<template>
  <div class="product-details-content-certificate-preview">
    <div class="position-relative">
      <svg
        v-if="template"
        width="100%"
        viewBox="0 0 1123 794"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <image
          x="0"
          y="0"
          width="100%"
          height="100%"
          preserveAspectRatio="xMinYMin slice"
          :href="template"
        />
      </svg>
      <svg
        v-else
        width="100%"
        viewBox="0 0 1123 794"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="1123" height="794" fill="#E5E5E5" />
        <g clip-path="url(#clip0_7880_161042)">
          <rect width="1123" height="794" fill="#F7F7F9" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M945.136 428.509L944.692 428L944.335 428.574L798.667 662.739L778.652 655.811L778.262 655.676L778.056 656.034L609.432 948.576L609 949.326H609.865H1316.12L1316.13 949.333L1316.14 949.326H1368.28H1369.25L1368.68 948.534L1114.57 594.817L1114.42 594.609H1114.17H1090.08L945.136 428.509ZM1316.57 948.326H1367.3L1113.91 595.609H1089.85H1089.74L1046.46 609.476L1046.05 609.608L1045.86 609.221L974.677 464.477H958.782L1106.85 774.028L1144.97 756.855L1145.3 756.705L1145.54 756.978L1316.57 948.326ZM944.827 429.676L974.323 463.477H957.464H956.964V463.977V477.567L943.189 467.618L942.874 467.391L942.576 467.64L928.436 479.423L920.906 468.129L944.827 429.676ZM799.581 663.163L920.326 469.062L927.521 479.854L854.619 680.998L799.581 663.163ZM798.403 663.706L778.716 656.891L610.731 948.326H702.699L798.403 663.706ZM704.011 948.326H859.499L859.005 815.235L834.252 839.202L833.404 840.023V838.843V741.459L704.011 948.326ZM834.3 739.994H834.404V837.663L865.296 807.752L939.502 651.883L942.504 469.001L928.648 480.547L928.221 480.904L928.21 480.887L834.3 739.994ZM940.502 651.86L943.503 469.079L957.171 478.95L957.964 479.523V478.545V465.083L1106.15 774.901L1106.36 775.341L1106.81 775.141L1144.73 758.056L1161.44 948.326H1088.97L1040.48 759.875L1040 760L1039.51 759.929L1012.52 948.326H946.556L996.486 741.235L996.535 741.03L996.423 740.852L940.502 651.86ZM1162.44 948.326H1315.23L1145.8 758.766L1162.44 948.326ZM1087.94 948.326L1040.14 762.55L1013.53 948.326H1087.94ZM945.528 948.326L995.035 742.985L860.5 909.083V948.326H945.528ZM976.561 466.041L1046.57 608.392L1088.94 594.816L976.561 466.041ZM995.345 741.015L940.061 653.036L866.16 808.263L866.121 808.344L866.056 808.407L860.001 814.27L860.348 907.681L995.345 741.015ZM799.316 664.128L854.278 681.939L833.368 739.631L704.826 945.137L799.316 664.128Z"
            fill="#E1DFE6"
          />
          <text
            fill="#736D80"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Inter"
            font-size="13.8797"
            font-weight="300"
            letter-spacing="0px"
          >
            <tspan x="880.488" y="655.858">Certificado e emitido por</tspan>
          </text>
          <g clip-path="url(#clip1_7880_161042)">
            <path
              d="M932.962 698.872C934.009 698.259 935.218 697.997 936.507 697.997C938.038 697.997 939.489 698.434 940.697 699.221C941.987 700.096 942.954 701.233 943.679 702.807C944.404 704.381 944.807 706.13 944.807 708.141C944.807 710.152 944.404 711.988 943.679 713.475C942.954 715.049 941.987 716.273 940.697 717.06C939.408 717.935 938.038 718.372 936.507 718.372C935.137 718.372 933.929 718.11 932.962 717.497C931.914 716.885 931.108 716.186 930.544 715.224V718.022H925.951V691.701H930.544V701.233C931.108 700.271 931.914 699.484 932.962 698.872ZM939.489 705.08C939.005 704.206 938.441 703.594 937.716 703.069C936.991 702.632 936.185 702.369 935.298 702.369C934.493 702.369 933.687 702.632 932.962 703.069C932.236 703.506 931.672 704.206 931.189 705.08C930.705 705.955 930.544 707.004 930.544 708.141C930.544 709.365 930.786 710.327 931.189 711.201C931.672 712.076 932.236 712.775 932.962 713.213C933.687 713.65 934.493 713.912 935.298 713.912C936.185 713.912 936.91 713.65 937.716 713.213C938.441 712.775 939.005 712.076 939.489 711.201C939.972 710.327 940.133 709.278 940.133 708.053C940.133 706.917 939.972 705.955 939.489 705.08Z"
              fill="#2B2733"
            />
            <path
              d="M952.785 691.701V718.11H948.192V691.701H952.785Z"
              fill="#2B2733"
            />
            <path
              d="M957.62 695.111C957.056 694.587 956.814 693.887 956.814 693.013C956.814 692.138 957.056 691.526 957.62 690.914C958.184 690.389 958.829 690.04 959.634 690.04C960.44 690.04 961.085 690.302 961.649 690.914C962.213 691.439 962.455 692.138 962.455 693.013C962.455 693.887 962.213 694.499 961.649 695.111C961.085 695.636 960.44 695.986 959.634 695.986C958.829 695.986 958.184 695.724 957.62 695.111ZM961.891 698.347V718.11H957.297V698.347H961.891Z"
              fill="#2B2733"
            />
            <path
              d="M971.802 702.457V711.988C971.802 712.688 971.964 713.125 972.286 713.475C972.608 713.737 973.092 713.912 973.817 713.912H975.912V718.11H973.011C969.143 718.11 967.209 716.098 967.209 711.988V702.457H965.033V698.347H967.209V693.45H971.802V698.347H975.912V702.457H971.802Z"
              fill="#2B2733"
            />
            <path
              d="M983.406 714H991.545V718.11H978.168V714.087L986.146 702.457H978.249V698.347H991.465V702.369L983.406 714Z"
              fill="#2B2733"
            />
            <path
              d="M1002.1 698.959C1003.15 698.347 1004.36 698.085 1005.65 698.085C1007.18 698.085 1008.63 698.522 1009.84 699.309C1011.13 700.183 1012.09 701.32 1012.82 702.894C1013.54 704.468 1013.95 706.217 1013.95 708.228C1013.95 710.239 1013.54 712.076 1012.82 713.562C1012.09 715.136 1011.13 716.361 1009.84 717.148C1008.55 718.022 1007.18 718.459 1005.65 718.459C1004.28 718.459 1003.15 718.197 1002.1 717.585C1001.05 716.973 1000.25 716.273 999.603 715.311V727.554H995.091V698.434H999.684V701.32C1000.25 700.271 1001.05 699.484 1002.1 698.959ZM1008.63 705.08C1008.14 704.206 1007.58 703.594 1006.86 703.069C1006.13 702.632 1005.32 702.369 1004.44 702.369C1003.63 702.369 1002.83 702.632 1002.1 703.069C1001.38 703.506 1000.81 704.206 1000.33 705.08C999.845 705.955 999.684 707.004 999.684 708.141C999.684 709.365 999.926 710.327 1000.33 711.201C1000.81 712.076 1001.38 712.775 1002.1 713.213C1002.83 713.65 1003.63 713.912 1004.44 713.912C1005.32 713.912 1006.05 713.65 1006.86 713.213C1007.58 712.775 1008.14 712.076 1008.63 711.201C1009.11 710.327 1009.27 709.278 1009.27 708.053C1009.27 706.917 1009.03 705.955 1008.63 705.08Z"
              fill="#2B2733"
            />
            <path
              d="M1017.25 702.807C1017.98 701.233 1018.94 700.096 1020.23 699.221C1021.52 698.347 1022.89 697.997 1024.42 697.997C1025.79 697.997 1027 698.259 1027.97 698.872C1029.02 699.484 1029.82 700.183 1030.39 701.145V698.347H1034.98V718.11H1030.39V715.224C1029.82 716.186 1029.02 716.885 1027.97 717.498C1026.92 718.11 1025.71 718.372 1024.34 718.372C1022.81 718.372 1021.44 717.935 1020.15 717.06C1018.86 716.186 1017.9 714.962 1017.17 713.475C1016.44 711.901 1016.04 710.152 1016.04 708.141C1016.12 706.13 1016.53 704.381 1017.25 702.807ZM1029.82 705.08C1029.42 704.206 1028.77 703.506 1028.05 703.069C1027.32 702.632 1026.52 702.369 1025.63 702.369C1024.74 702.369 1024.02 702.632 1023.29 703.069C1022.57 703.506 1022.01 704.206 1021.52 705.08C1021.04 705.955 1020.88 707.004 1020.88 708.141C1020.88 709.365 1021.12 710.327 1021.52 711.289C1022.01 712.163 1022.57 712.863 1023.29 713.3C1024.02 713.737 1024.83 714 1025.63 714C1026.52 714 1027.32 713.737 1028.05 713.3C1028.77 712.863 1029.42 712.163 1029.82 711.289C1030.22 710.414 1030.47 709.365 1030.47 708.141C1030.47 707.004 1030.22 705.955 1029.82 705.08Z"
              fill="#2B2733"
            />
            <path
              d="M1056.98 698.347L1045.7 727.466H1040.78L1044.73 717.672L1037.48 698.434H1042.63L1047.31 712.251L1052.06 698.434H1056.98V698.347Z"
              fill="#2B2733"
            />
            <path
              d="M895.41 673.163C895.41 673.075 895.33 672.988 895.249 672.9C895.169 672.813 895.088 672.813 895.008 672.813H891.865C891.784 672.813 891.623 672.9 891.543 672.988C891.462 673.075 891.381 673.163 891.381 673.337V682.169C891.381 682.257 891.462 682.432 891.543 682.519C891.623 682.607 891.704 682.694 891.865 682.694C892.026 682.694 892.107 682.607 892.187 682.519C892.268 682.432 892.348 682.344 892.348 682.169V677.71H894.846L894.927 678.322C894.927 678.584 895.169 678.672 895.33 678.672H897.586C897.667 678.672 897.828 678.584 897.909 678.497C897.989 678.409 898.07 678.322 898.07 678.147V674.212C898.07 674.124 897.989 673.95 897.909 673.862C897.828 673.775 897.747 673.687 897.586 673.687H895.572L895.41 673.163Z"
              fill="#BC5CAF"
            />
            <path
              d="M900.487 719.859H886.305L897.022 691.439H911.205C915.798 691.439 918.054 695.549 916.12 700.533L912.252 710.677C910.399 715.836 905.081 719.859 900.487 719.859Z"
              fill="#9155EC"
            />
            <path
              d="M897.103 691.526L892.51 680.421C892.268 679.808 891.14 680.158 890.817 681.033L876.071 719.946H886.305L897.103 691.526Z"
              fill="#BC5CAF"
            />
            <path
              d="M907.659 716.973L897.103 691.439H897.022L876.071 719.859H900.487C902.905 719.859 905.483 718.722 907.659 716.973Z"
              fill="#EE6469"
            />
            <path
              opacity="0.55"
              d="M911.205 691.526H897.103L892.51 680.421C892.429 680.333 892.348 680.246 892.268 680.158V677.622H894.766L894.846 678.234C894.846 678.497 895.088 678.584 895.249 678.584H897.506C897.586 678.584 897.747 678.497 897.828 678.409C897.909 678.322 897.989 678.234 897.989 678.059V674.212C897.989 674.124 897.909 673.95 897.828 673.862C897.747 673.775 897.667 673.687 897.506 673.687H895.491L895.411 673.075C895.411 672.988 895.33 672.9 895.249 672.813C895.169 672.725 895.088 672.725 895.008 672.725H891.865C891.784 672.725 891.623 672.813 891.543 672.9C891.462 672.988 891.381 673.075 891.381 673.25V680.333C891.14 680.508 890.978 680.683 890.898 680.945L876.151 719.859H886.305H900.487C900.81 719.859 901.051 719.859 901.374 719.771C901.454 719.771 901.535 719.771 901.615 719.771C901.857 719.771 902.099 719.684 902.341 719.684C902.421 719.684 902.502 719.684 902.582 719.596C902.824 719.509 903.066 719.509 903.308 719.421C903.388 719.421 903.388 719.421 903.469 719.334C903.71 719.246 903.952 719.159 904.275 719.072H904.355C904.597 718.984 904.919 718.809 905.161 718.722C905.161 718.722 905.161 718.722 905.242 718.722C905.564 718.547 905.806 718.459 906.128 718.285C908.868 716.623 911.285 713.912 912.494 710.852L916.362 700.708C918.054 695.549 915.878 691.526 911.205 691.526Z"
              fill="url(#paint0_linear_7880_161042)"
            />
          </g>
          <path
            d="M14.9999 777V15.5H1107V777H14.9999Z"
            stroke="url(#paint1_linear_7880_161042)"
            stroke-width="2"
          />
          <path
            d="M32.9999 32.9827L33.7874 759.482L1089 759.127V33"
            stroke="url(#paint2_linear_7880_161042)"
            stroke-width="2"
          />
          <path
            d="M14 778.5V494L248.113 778.5H14Z"
            fill="url(#paint3_linear_7880_161042)"
          />
          <path d="M33 651V759H144" stroke="white" stroke-width="1.37378" />
          <path
            d="M941 201.5L311.475 20.6835L163.238 108.7L14 197V14.5H1108L941 201.5Z"
            fill="url(#paint4_linear_7880_161042)"
          />
          <path
            d="M141 33L33 33L33 144"
            stroke="white"
            stroke-width="1.37378"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M953.829 341.488C955.222 341.987 956.373 342.4 957.938 342.4C958.597 342.4 959.915 342.4 960.574 341.741L964.528 367.442L944.758 354.262L924.987 367.442L928.282 341.741C929.6 342.4 930.259 342.4 931.577 342.4C933.554 342.4 935.531 341.741 936.849 341.082L944.758 337.787L952.666 341.082C953.078 341.219 953.462 341.357 953.829 341.488ZM977.049 296.269C976.39 297.587 976.39 299.564 977.049 300.882L980.344 310.108C981.662 312.744 979.685 316.039 977.049 317.357L968.482 320.652C967.164 321.311 965.846 322.629 965.187 323.947L961.892 332.514C960.574 334.491 958.597 335.81 956.62 335.81C955.961 335.81 955.302 335.81 954.643 335.15L946.076 331.196C945.417 330.537 944.758 330.537 944.099 330.537C943.769 330.537 943.439 330.702 943.11 330.867C942.78 331.032 942.451 331.196 942.121 331.196L933.554 335.15C932.895 335.81 932.236 335.81 931.577 335.81C929.6 335.81 927.623 334.491 926.964 331.855L923.669 323.288C923.01 321.97 921.692 320.652 920.374 319.993L911.807 316.698C908.512 315.38 907.194 312.085 908.512 309.449L912.466 301.541C913.125 300.223 913.125 298.246 912.466 296.928L908.512 288.36C907.194 285.065 908.512 281.77 911.148 281.111L920.374 277.816C921.692 277.157 923.01 275.839 923.01 274.521L926.305 265.295C927.623 263.318 929.6 262 931.577 262C932.236 262 933.554 262 934.213 262.659L942.78 265.954C943.439 266.613 944.099 266.613 944.758 266.613H946.735L955.302 262.659C955.961 262 957.279 262 957.938 262C959.915 262 961.892 263.318 962.551 265.954L965.846 274.521C966.505 275.839 967.823 277.157 969.141 277.816L977.708 281.111C981.003 282.429 982.321 285.724 981.003 288.36L977.049 296.269ZM918.397 298.905C918.397 313.403 930.259 325.265 944.758 325.265C959.256 325.265 971.118 313.403 971.118 298.905C971.118 284.406 959.256 272.544 944.758 272.544C930.259 272.544 918.397 284.406 918.397 298.905ZM958.737 312.884C962.444 309.177 964.527 304.148 964.527 298.905C964.527 293.661 962.444 288.633 958.737 284.925C955.029 281.217 950 279.134 944.757 279.134C939.513 279.134 934.485 281.217 930.777 284.925C927.069 288.633 924.986 293.661 924.986 298.905C924.986 304.148 927.069 309.177 930.777 312.884C934.485 316.592 939.513 318.675 944.757 318.675C950 318.675 955.029 316.592 958.737 312.884Z"
            fill="url(#paint5_linear_7880_161042)"
          />
          <path
            d="M944.498 286.117C944.498 286.044 944.425 286.044 944.425 285.972C944.425 285.899 944.351 285.899 944.278 285.899H942.665C942.592 285.899 942.518 285.899 942.518 285.972C942.445 286.044 942.445 286.044 942.445 286.117V290.106C942.445 290.179 942.445 290.251 942.518 290.251C942.592 290.324 942.592 290.324 942.665 290.324C942.738 290.324 942.812 290.324 942.812 290.251C942.885 290.179 942.885 290.179 942.885 290.106V288.075H944.131L944.205 288.366C944.205 288.438 944.351 288.511 944.425 288.511H945.598C945.671 288.511 945.745 288.511 945.745 288.438C945.818 288.366 945.818 288.366 945.818 288.293V286.552C945.818 286.48 945.818 286.407 945.745 286.407C945.671 286.335 945.671 286.335 945.598 286.335H944.571L944.498 286.117Z"
            fill="white"
          />
          <path
            d="M945.305 294.458L943.032 289.381C942.885 289.091 942.372 289.236 942.225 289.671L934.82 307.442H939.952L945.305 294.458Z"
            fill="white"
          />
          <path
            d="M952.417 294.458H946.331L951.317 305.484C951.977 304.831 952.564 304.106 952.93 303.235L954.837 298.593C955.79 296.344 954.69 294.458 952.417 294.458Z"
            fill="white"
          />
          <path
            d="M950.584 306.064L945.305 294.458L934.82 307.37H946.991C948.238 307.37 949.484 306.862 950.584 306.064Z"
            fill="white"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_7880_161042"
            x1="876.088"
            y1="696.309"
            x2="916.834"
            y2="696.309"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#EE6469" />
            <stop offset="1" stop-color="#9155EC" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_7880_161042"
            x1="33.029"
            y1="458"
            x2="569.904"
            y2="19.626"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.618988" :stop-color="color_1" />
            <stop offset="0.850631" :stop-color="color_2" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_7880_161042"
            x1="40.7949"
            y1="448"
            x2="554.345"
            y2="22.3788"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.618988" :stop-color="color_1" />
            <stop offset="0.850631" :stop-color="color_2" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_7880_161042"
            x1="33.4784"
            y1="455.872"
            x2="610.739"
            y2="197.249"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.00016548" :stop-color="color_1" />
            <stop offset="0.95" :stop-color="color_2" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_7880_161042"
            x1="9"
            y1="368.5"
            x2="50.1861"
            y2="-39.1077"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.6628" :stop-color="color_1" />
            <stop offset="0.985193" :stop-color="color_2" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_7880_161042"
            x1="10.608"
            y1="824.243"
            x2="1178.96"
            y2="325.973"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.768527" :stop-color="color_1" />
            <stop offset="0.80858" :stop-color="color_1" />
            <stop offset="0.860181" :stop-color="color_2" />
          </linearGradient>
          <clipPath id="clip0_7880_161042">
            <rect width="1123" height="794" fill="white" />
          </clipPath>
          <clipPath id="clip1_7880_161042">
            <rect
              width="181.048"
              height="54.8285"
              fill="white"
              transform="translate(876 672.725)"
            />
          </clipPath>
        </defs>
      </svg>

      <div class="body" :style="bodyStyle">
        <h1 v-if="typography === 'Parisienne' || typography === 'Great Vibes'">
          Certificado
        </h1>
        <h1 v-else>CERTIFICADO</h1>
        <div class="text">
          Certificamos para os devidos fins, que
          <br />
          <strong>
            Nome do aluno
          </strong>
          <br />
          concluiu com êxito o curso online <br />
          <strong> {{ courseName || "Curso Exemplo" }} </strong>
          .
        </div>
        <div class="finished-at">
          Realizado no período de &nbsp;<strong>19/04/2023</strong>
          &nbsp;a&nbsp; <strong>21/04/2023</strong> &nbsp;cumprindo <br />
          uma carga horária de &nbsp;<strong
            >{{ hourly_load || "15" }}&nbsp;horas.</strong
          >
        </div>
        <div class="box-signature">
          <img
            v-if="image_signature"
            class="signature"
            :src="image_signature"
          />
          <span v-else class="signature" :style="signatureStyle">
            {{ organizer_name || "Blitzpay Cursos" }}
          </span>

          <div class="organizer">
            {{ organizer_name || "BlitzPay Cursos" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    courseName: {
      type: String
    },
    hourly_load: {
      type: [Number, String]
    },
    organizer_name: {
      type: String
    },
    image_signature: {
      type: String
    },
    color_1: {
      type: String
    },
    color_2: {
      type: String
    },
    typography: {
      type: String
    },
    textColor: {
      type: String
    },
    template: {
      type: String,
      default: ""
    },
    signature_typography: String
  },
  computed: {
    bodyStyle() {
      return {
        "font-family": this.typography,
        color: this.textColor
      };
    },
    signatureStyle() {
      return {
        "font-family": this.signature_typography || this.typography
      };
    }
  }
};
</script>

<style lang="scss" scoped>
// body fonts
@import url("https://fonts.googleapis.com/css?family=Bellota&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Voces&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Poiret+One&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Parisienne&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Simonetta&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Great+Vibes&display=swap");

// signature fonts
@import url("https://fonts.googleapis.com/css2?family=Whisper&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Allison&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Ms+Madi&display=swap");

.product-details-content-certificate-preview {
  .body {
    position: absolute;
    top: 19%;
    left: 15%;
    right: 15%;
    text-align: center;
  }

  h1 {
    font-weight: 700;
    font-size: 30px;
    margin-bottom: 24px;
    @media screen and (max-width: 1199px) {
      margin-bottom: 2vw;
      line-height: 150%;
      font-size: 3vw;
    }
    @media screen and (max-width: 991px) {
      font-size: 5vw;
    }
  }

  .text {
    width: 80%;
    margin: 5px 10% 30px;
    font-size: 12px;
    @media screen and (max-width: 1199px) {
      line-height: 160%;
      font-size: 1.5vw;
    }
    @media screen and (max-width: 991px) {
      font-size: 2vw;
    }
  }

  .finished-at {
    font-size: 9.6px;
    @media screen and (max-width: 1199px) {
      font-size: 1.3vw;
    }
    @media screen and (max-width: 991px) {
      font-size: 1.8vw;
    }
  }

  strong {
    filter: brightness(0.9);
  }

  .organizer {
    width: 35%;
    border-top: 1px solid #d2d0d8;
    margin: 0 25%;
    font-weight: 700;
    font-size: 9.6px;
    padding-top: 10px;
    display: block;
    @media screen and (max-width: 1199px) {
      line-height: 150%;
      font-size: 1.2vw;
    }
    @media screen and (max-width: 991px) {
      font-size: 1.5vw;
    }
  }

  .box-signature {
    height: 85px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    @media screen and (max-width: 1199px) {
      height: 10vw;
    }
    @media screen and (max-width: 991px) {
      height: 13vw;
    }
    @media screen and (max-width: 780px) {
      height: 11vw;
    }
  }
  .signature {
    padding-top: 24px;
    max-width: 450px;
    max-height: 50px;
    margin-top: 21px;
    font-size: 12px;
    white-space: nowrap;

    @media screen and (max-width: 1400px) {
      max-height: 40px;
    }
    @media screen and (max-width: 991px) {
      max-height: 45px;
    }
    @media screen and (max-width: 420px) {
      max-height: 35px;
    }
  }

  .empty {
    padding-top: 80px;
  }

  .position-relative {
    box-shadow: 0px 4.99685px 6px rgba(0, 0, 0, 0.1),
      0px 8px 16px 8px rgba(0, 0, 0, 0.05);
  }
}
</style>
